module.exports = __webpack_public_path__ + "img/Burkina-Faso.5759eb38.png";